import * as queryString from 'query-string';

export const getNextAvailableConfigForTheDay = (axiosInstance, eventId, params) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/day-config`, {
        params: {
            date: params.date,
        },
    });
};

export const getDefaultNextAvailableConfig = (axiosInstance, eventId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/day-config`);
};

export const saveNextAvailableConfig = (axiosInstance, eventId, params) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/day-config`, params);
};

export const getAvailableDrawsToAddForDay = (axiosInstance, eventId, dayConfigId, facilityId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/draws/available`, {
        params: {
            facilityId,
            dayConfigId,
        },
    });
};

export const addDrawsToFacilityAndDay = (axiosInstance, eventId, dayConfigId, facilityId, drawIds) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/add`, {
        dayConfigId,
        facilityId,
        drawIds,
    });
};

export const getDrawsForFacilityAndDay = (axiosInstance, eventId, dayConfigId, facilityId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/draws`, {
        params: {
            facilityId,
            dayConfigId,
        },
    });
};

export const removeDrawFromFacilityAndDay = (axiosInstance, eventId, drawIds, dayConfigId, facilityId) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/remove`, {
        drawIds,
        facilityId,
        dayConfigId,
    });
};

export const removeAllDrawsFromFacilityAndDay = (axiosInstance, eventId, dayConfigId, facilityId) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/remove-all`, {
        facilityId,
        dayConfigId,
    });
};

export const startDrawAddedToFacilityAndDay = (axiosInstance, eventId, drawIds, notifyPlayers, dayConfigId, facilityId) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/start`, {
        drawIds,
        notifyPlayers,
        dayConfigId,
        facilityId,
    });
};

export const getMatchesForFacilityAndDay = (axiosInstance, eventId, dayConfigId, facilityId, matchStatuses) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/matches`, {
        params: {
            facilityId,
            dayConfigId,
            drawMatchStatus: matchStatuses,
        },
        paramsSerializer: params => {
            return queryString.stringify(params);
        },
    });
};

export const getSummaryForFacilityAndDay = (axiosInstance, eventId, dayConfigId, facilityId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/summary`, {
        params: {
            facilityId,
            dayConfigId,
        },
    });
};

export const scheduleMatch = (axiosInstance, eventId, matchId, params) => {
    const { dayConfigId, facilityId, drawId, courtId } = params;
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/${drawId}/schedule-match`, {
        dayConfigId,
        facilityId,
        matchId,
        courtId,
    });
};

export const reScheduleMatch = (axiosInstance, eventId, matchId, params) => {
    const { dayConfigId, facilityId, drawId, courtId } = params;
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/${drawId}/reschedule-match`, {
        dayConfigId,
        facilityId,
        matchId,
        courtId,
    });
};

export const unScheduleMatch = (axiosInstance, eventId, matchId, params) => {
    const { dayConfigId, facilityId, drawId } = params;
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/${drawId}/unschedule-match`, {
        dayConfigId,
        facilityId,
        matchId,
    });
};

export const startMatch = (axiosInstance, eventId, matchId, params) => {
    const { dayConfigId, facilityId, drawId, courtId } = params;
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/${drawId}/start-match`, {
        dayConfigId,
        facilityId,
        matchId,
        courtId,
    });
};

export const pauseMatch = (axiosInstance, eventId, matchId, params) => {
    const { dayConfigId, facilityId, drawId, courtId } = params;
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/${drawId}/pause-match`, {
        dayConfigId,
        facilityId,
        matchId,
        courtId,
    });
};

export const postScore = (axiosInstance, eventId, matchId, params) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/post-score`, {
        ...params,
        matchId,
    });
};

export const getPublishedDraws = (axiosInstance, eventId, facilityId = null) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/schedule`, {
        params: {
            facilityId,
        },
    });
};

export const publishDraws = (axiosInstance, eventId, dayConfigId, facilityId) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/draws/publish`, {
        dayConfigId,
        facilityId,
    });
};

export const getLiveMatches = (axiosInstance, eventId, matchStatuses = [], selectedFacilities = []) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/live-matches`, {
        params: {
            drawMatchStatus: matchStatuses,
            facilityIds: selectedFacilities,
        },
        paramsSerializer: params => {
            return queryString.stringify(params);
        },
    });
};

export const getFacilities = (axiosInstance, eventId) => {
    return axiosInstance.get(`v2/tms/events/${eventId}/next-available/facilities`);
};

export const createPrintConfig = (axiosInstance, eventId, clubLocationFacilityId, clubLocationFacilityName) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/print-config?ClubLocationFacilityId=${clubLocationFacilityId}&ClubLocationFacilityName=${clubLocationFacilityName}`);
};

export const postPrintTestPage = (axiosInstance, eventId, clubLocationFacilityId, clubLocationFacilityName, operationQueueId) => {
    return axiosInstance.post(`v2/tms/events/${eventId}/next-available/test-print-sheet?ClubLocationFacilityId=${clubLocationFacilityId}&ClubLocationFacilityName=${clubLocationFacilityName}&OperationQueueId=${operationQueueId}`);
};
